// トリガーの名前と種類

export const triggerNameAndType = {
  "ATTACK TRIGGER" : [
    "弧月",
    "弧月(改)：槍",
    "スコーピオン",
    "スコーピオン(改)",
    "レイガスト",
    "双月",
  ],
  "GUNNER TRIGGER" : [
    "アステロイド",
    "ハウンド",
    "ハウンド(改)",
    "メテオラ",
    "バイパー",
    "アステロイド：拳銃",
    "ハウンド：拳銃",
    "バイパー：拳銃",
    "アステロイド：突撃銃",
    "ハウンド：突撃銃",
    "メテオラ：突撃銃",
    "バイパー：突撃銃",
    "アステロイド：散弾銃",
    "アステロイド：機関砲",
    "メテオラ：擲弾銃",
  ],
  "SNIPER TRIGGER" : [
    "アイビス",
    "イーグレット",
    "ライトニング"
  ],
  "DEFFENSE TRIGGER" : [
    "シールド",
    "エスクード"
  ],
  "TRAP TRIGGER" : [
    "スイッチボックス",
  ],
  "OPTION TRIGGER" : [
    "バッグワーム",
    "バッグワームタグ",
    "カメレオン",
    "グラスホッパー",
    "スパイダー",
    "スパイダー(改)：拳銃",
    "スラスター",
    "スラスター(改)",
    "サイレンサー",
    "スタアメーカー",
    "ダミービーコン(試作)",
    "ガイスト(試作)",
    "フルアームズ(試作)",
    "タイマー(試作)",
    "テレポーター(試作)",
    "コネクター(試作)",
    "旋空",
    "鉛弾",
    "鉛弾(改)",
    "強化レーダー",
    "幻踊",
    "魔光(試作)",
    "韋駄天(試作)",
  ]
};
